import React from "react";

import { Button, Popover, Portal } from "@libs/design";
import { LogOut } from "@assets/icons";

type PopoverMenuProps = {
  trigger: React.ReactNode;
  onLogout?: () => void;
  isLoading?: boolean;
};

export const LogoutPopover: React.FC<PopoverMenuProps> = ({
  trigger,
  onLogout,
  isLoading = false,
}) => {
  return (
    <Popover.Root positioning={{ placement: "bottom-end" }} closeOnInteractOutside closeOnEscape>
      <Popover.Trigger asChild>{trigger}</Popover.Trigger>

      <Portal>
        <Popover.Positioner>
          <Popover.Content borderRadius="md" boxShadow="md" w="10rem" shadow="lg">
            <Popover.Body p={1} color="green.500">
              <Button
                variant="subtle"
                bg="transparent"
                color="black"
                size="sm"
                w="full"
                justifyContent="flex-start"
                onClick={onLogout}
                disabled={isLoading}
              >
                <LogOut size={16} />
                Logout
              </Button>
            </Popover.Body>
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  );
};
